import React, { useState } from 'react';
import { useThemeMode } from '../../../../_metronic/partials';
import useSize from '../../../hooks/useSize';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import styles from './login.module.css';

const generateCodeVerifier = () => {
    const array = new Uint8Array(32);
    window.crypto.getRandomValues(array);
    return btoa(String.fromCharCode.apply(null, Array.from(array)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
};

const generateCodeChallenge = async (verifier: string) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const digest = await window.crypto.subtle.digest('SHA-256', data);
    return btoa(String.fromCharCode.apply(null, Array.from(new Uint8Array(digest))))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
};

export function LekkoLoginButton() {
    const [loading, setLoading] = useState(false);
    //const theme = localStorage.getItem('theme') || 'light';
    const { mode } = useThemeMode();
    const { width } = useSize();

    const handleLekkoLogin = async () => {
        setLoading(true);
        const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'solar-vision';
        const authUrl = process.env.REACT_APP_LEKKO_AUTH_URL || 'https://account.lekko.com.br/realms/lekko/protocol/openid-connect/auth';
        const redirectUri = `${window.location.origin}/auth/lekko/callback`;

        const verifier = generateCodeVerifier();
        const challenge = await generateCodeChallenge(verifier);

        sessionStorage.setItem('lekko_pkce_verifier', verifier);

        const params = new URLSearchParams({
            client_id: clientId,
            response_type: 'code',
            redirect_uri: redirectUri,
            code_challenge: challenge,
            code_challenge_method: 'S256',
            scope: 'openid email profile',
            theme: mode,
        });

        window.location.href = `${authUrl}?${params.toString()}`;
    };

    if (width < 1200) {
        return <></>;
    }

    return (
        <div className='d-grid mb-5 mt-2'>
            <div className='d-flex align-items-center mb-6' style={{ gap: '1rem' }}>
                <div className='flex-grow-1 border-top border-gray-300'></div>
                <span className='text-gray-500 fw-semibold fs-6'>ou</span>
                <div className='flex-grow-1 border-top border-gray-300'></div>
            </div>

            <button
                type='button'
                onClick={handleLekkoLogin}
                className={`btn fw-bold fs-5 py-4 ${styles.lekkoButton}`}
                disabled={loading}
            >
                {!loading && (
                    <span className='indicator-label d-flex align-items-center justify-content-center' style={{ gap: '0.75rem' }}>
                        <img
                            src={toAbsoluteUrl('/media/logos/lekko-icon.png')}
                            alt=''
                            className={styles.lekkoLogo}
                        />
                        Entrar com conta Lekko
                    </span>
                )}
                {loading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                        Redirecionando...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                )}
            </button>
        </div>
    );
}
